module.exports = __webpack_public_path__ + "static/img/reward-coin-receiced.ef51361.png";